import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SitemapService } from '../shared/services/sitemap.service';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-sitemap',
  standalone: true,
  imports: [CommonModule],
  template: '<pre>{{ sitemapXml }}</pre>',
  styles: [
    `
      pre {
        white-space: pre-wrap;
        word-wrap: break-word;
        font-family: monospace;
        padding: 1rem;
        background: #f5f5f5;
        border-radius: 4px;
      }
    `,
  ],
})
export class SitemapComponent implements OnInit {
  private sitemapService = inject(SitemapService);
  private document = inject(DOCUMENT);
  sitemapXml = '';

  ngOnInit(): void {
    this.sitemapXml = this.sitemapService.generateSitemap();
    
    // Set proper content type header (would be handled by server in production)
    // For client-side, we display it in the template
    // In production with SSR, this should return XML with proper headers
  }
}

